import {
  createSlice, PayloadAction, createAsyncThunk,
} from '@reduxjs/toolkit';
import { doPatchRequest } from '../../../common/request';
import { appConfig } from '../../../common/config';
import { getValidSerialNumbers } from '../../../common/helper';

interface DevicesDeactivationState {
  result?: any;
  isLoading: boolean;
  errMsg?: string;
}

const initialState: DevicesDeactivationState = {
  isLoading: false,
};

// Handle actions in your reducers
const devicesDeactivationSlice = createSlice({
  name: 'devicesDeactivation',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.errMsg = undefined;
      state.isLoading = true;
      state.result = undefined;
    },
    setResult: (state, action: PayloadAction<any>) => {
      state.result = action.payload;
      state.isLoading = false;
    },
    setError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.result = undefined;
      state.errMsg = action.payload;
    },
    reset(state) {
      state.errMsg = undefined;
    }
  },
});

export const deactivateDevices = createAsyncThunk<void, {serialNumbers: string[]}>(
  'devicesDeactivation/deactivateDevices',
  async (params, thunkAPI) => {
    try {
      if (!params.serialNumbers.length) {
        thunkAPI.dispatch(devicesDeactivationSlice.actions.setError(appConfig.msgs.noSerialsInput));
        return;
      }
      const filteredSerials = getValidSerialNumbers(params.serialNumbers);
      if (filteredSerials.length !== params.serialNumbers.length) {
        thunkAPI.dispatch(devicesDeactivationSlice.actions.setError(appConfig.msgs.someInvalidSerials));
        return;
      }
      thunkAPI.dispatch(devicesDeactivationSlice.actions.setLoading());
      const body: any = {
        SerialNumbers: filteredSerials,
        UnsubscribeNetwork: true,
        RemoveFromLosant: true,
      }
      const result = await doPatchRequest(`${appConfig.settings.pipApiBase}/deactivateDevices`, body, false);
      thunkAPI.dispatch(devicesDeactivationSlice.actions.setResult(result));
    } catch (err: any) {
      thunkAPI.dispatch(devicesDeactivationSlice.actions.setError(err.message));
    }
  },
);

export const {
  reset,
} = devicesDeactivationSlice.actions;

export default devicesDeactivationSlice.reducer;
